import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip
} from "react-bootstrap"
import {
  HiRefresh
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'

export const ButtonRevision: React.FC <ButtonCreateInterface> = ({
  text,
  icon,
  noText = false,
  variant,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  size = "sm",
  style,
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Revise data'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        variant={variant ?? "warning"}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        style={{
          ...style,
          minWidth: icon ? 'auto' : '100px' 
        }}
      >
        <div className="d-flex justify-content-center align-items-center text-white">
          <div>
            {icon && <HiRefresh className="mb-1" />}
          </div>
          {!noText && (
            <span className="mx-1 text-uppercase">
              {text  ? text : 'Revise'}
            </span>
          )}
        </div>
      </Button>
    </OverlayTrigger>
  )
}